import _ from 'lodash';
import {
  createAttachment,
  updateAttachmentById,
} from './api';

const generateDefaultAttachmentItem = (fileData) => {
  const newAttachmentItem = {
    name: fileData.filename,
    type: fileData.type,
    baseUrl: fileData.baseUrl,
    fileSize: fileData.fileSize,
    status: 'published',
    isPublishOnFirstAirAt: false,
  };
  return _.cloneDeep(newAttachmentItem);
};

const postAttachments = (attachmentId, payload) => {
  if (payload.id) {
    return createAttachment(payload);
  }
  return updateAttachmentById(attachmentId, payload);
};

export {
  generateDefaultAttachmentItem,
  postAttachments,
};
